import { RpmAccount } from '../../store/RpmAccount';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getRpmAccount = (accountId: string) => {
  return apiService.callExternalApi<RpmAccount>({
    url: `${API_SERVER_URL}/rpm-accounts/${accountId}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const listRpmAccounts = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters
  };

  return apiService.callExternalApi<PaginatedResponse<RpmAccount>>({
    url: buildAdvancedQueryURL(mergedFilters, 'rpm-accounts'),
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const patchRpmAccount = (rpmAccount: RpmAccount) => {
  return apiService.callExternalApi<RpmAccount>({
    url: `${API_SERVER_URL}/rpm-accounts/${rpmAccount.accountId}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(rpmAccount)
  });
};

export const bulkPatchRpmAccount = (rpmAccounts: Partial<RpmAccount>[]) => {
  return apiService.callExternalApi<RpmAccount[]>({
    url: `${API_SERVER_URL}/rpm-accounts`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(rpmAccounts)
  });
};

export const validateRpmAccountDeletable = (accountId: string) => {
  return apiService.callExternalApi<{ deletable: boolean }>({
    url: `${API_SERVER_URL}/rpm-accounts/validate-deletable/${accountId}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getCommissionRunInfoByAccounts = (accountIds: number[]) => {
  return apiService.callExternalApi<{ firstCommissionRun: string | null; lastCommissionRun: string | null }>({
    url: `${API_SERVER_URL}/rpm-accounts/commission-run-info`,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data: JSON.stringify(accountIds)
  });
};

export const deleteRpmAccount = (accountId: string) => {
  return apiService.callExternalApi<boolean>({
    url: `${API_SERVER_URL}/rpm-accounts/${accountId}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};
